class InsuranceAutomatic {
    constructor(active, commissionValue, insurance) {
        this.active = active
        this.commissionValue = commissionValue
        this.insurance = insurance
    }

    static fromJson({ active, commissionValue, insurance }) {
        return new InsuranceAutomatic(active, commissionValue, insurance)
    }
}

export default InsuranceAutomatic
